export const DeliveryAlreadyProcessedException = "Delivery already processed."

export interface IOrderListItem {
  Id: string
  Total: number
  CustomerId: string
  Created: string
  Pending: string
  Rejected: any
  Cancelled: any
  Packed: string
  Queued: string
  Assigned: string
  Dispatched: any
  OutForDelivery: string
  Failed: any
  Delivered: any
  Returned: any
  ManuallyRefunded: any
  RejectionReason: string
  CancellationReason: string
  FailedReason: string
  ReturnReason: string
  DeliveryTrackingUrl: string
  ShopId: string
  ShopPickupAddressLine1: string
  ShopPickupAddressLine2: string
  ShopPickupAddressLine3: string
  ShopPickupAddressPostCode: string
  ShopPickupAddressCounty: string
  ShopPickupAddressCity: string
  ShopPickupAddressLat: number
  ShopPickupAddressLong: number
  ShopTelNo: string
  ShopName: string
  TimeSlotFrom: string
  TimeSlotTo: string
  DriverId: string
  DriverSourceRef: string
  DriverName: string
  OrderNo: number
  LatestUpdateForArchived: any
  Status: string
  ShopPortalStatus: string
  ProOrderStatus?: string
}
